import { useQuery } from "@tanstack/react-query";
import { LootBoxApi, LootBoxPlacementContext, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetActiveLootBoxConfigs(fullToken: Token, context?: LootBoxPlacementContext) {
    return useQuery({
        queryKey: ["active-lootbox-configs", context ?? "all", fullToken?.id ?? "unauthenticated"],
        queryFn: () => new LootBoxApi(getConfig(fullToken)).getLootboxConfigsActive({ context }),
        staleTime: 60 * 1000,
    });
}
